import { gql } from 'urql';

const UPDATE_TEAM_MEMBER = gql`
  mutation UpdateTeamMember($id: Int!, $set: team_members_set_input!) {
    update_team_members_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
    }
  }
`;

export default UPDATE_TEAM_MEMBER;
